import styled from 'styled-components'

const WrapFilterTrans = styled.div`
    position: relative;
`;

export {
    WrapFilterTrans
}